import { type ServiceMethod } from '@/application/interfaces/service';

import { type PendingOrderData } from '../model';

export interface Response {
  data: PendingOrderData[];
}

const getPendingSaleOrders: ServiceMethod<Response> =
  (httpClient) => async (options) => {
    const { body } = await httpClient.get<Response, undefined, undefined>(
      `/api/v3/sale-order/pending-payment-store-orders`,
      options
    );

    return body;
  };

export default getPendingSaleOrders;
